<template>
  <custom-dialog
    :show="show"
    :title="title"
    @toggleShow="handleClose"
    :appendToBody="true"
    width="398"
  >
    <div class="flex form" slot="main">
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-width="98px"
        label-position="right"
      >
        <el-form-item
          :label="$t(item.label) + '：'"
          v-for="item in currentFormItem"
          :key="item.key"
          :prop="item.key"
        >
          <template v-if="item.inputType == 'tree'">
            <el-select
              style="width: 100%"
              :disabled="editOrgState == 2"
              size="mini"
              v-model="form.pname"
              popper-class="orgId"
            >
              <el-option :value="form.org" style="height: auto">
                <el-tree
                  ref="tree"
                  :data="orgdata"
                  show-checkbox
                  style="font-weight: 400; pointer-events: auto"
                  node-key="id"
                  default-expand-all
                  :props="defaultProps"
                  :check-strictly="true"
                  @check="handleCheckChange"
                >
                </el-tree>
              </el-option>
            </el-select>
          </template>
          <template v-else-if="item.inputType == 'textarea'">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入内容"
              v-model="form.describe"
              maxlength="200"
            >
            </el-input>
          </template>
          <template v-else>
            <el-input
              size="small"
              style="width: 268px"
              v-model="form[item.key]"
              :placeholder="$t(item.label)"
            ></el-input>
          </template>
        </el-form-item>
      </el-form>
    </div>

    <div class="flex btns" slot="footer">
      <el-button
        type="success"
        class="btn cancel"
        size="small"
        @click="handleClose()"
      >
        {{ $t("public.close") }}
      </el-button>
      <el-button type="primary" class="btn save" size="small" @click="save">
        {{ $t("public.save") }}
      </el-button>
    </div>
  </custom-dialog>
</template>

<script>
import { createOrg, checkOrgName, editOrg } from "@/api/index";
import CustomDialog from "../../../components/public/customDialog";
export default {
  name: "EditSn",
  components: {
    CustomDialog,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    editOrgState: {
      type: Number,
      default: 1, // 1 新增  2 编辑
    },
    orgdata: {
      type: [Object, Array],
      default: () => {
        return [];
      },
    },
    rowInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    // 校验账号
    var validateOrg = (rule, value, callback) => {
      if (!value) {
        // this.$t("dialog.userList.edit_title")
        callback(new Error("请输入机构名称"));
      } else {
        checkOrgName({ name: value }).then((res) => {
          if (
            (res.data !== 1 && this.editOrgState == 1) ||
            this.editOrgState !== 1
          ) {
            callback();
          } else {
            callback(new Error("机构名称已存在"));
          }
        });
      }
    };
    return {
      defaultProps: {
        children: "children",
        label: "label",
        // children: "children",
        // label: (data, node) => {
        //   return data.name;
        // },
        // isLeaf: (data, node) => {
        //   if (typeof data.leaf !== "undefined") {
        //     return data.leaf;
        //   } else {
        //     return true;
        //   }
        // },
      },
      formItem: [
        {
          label: "dialog.open.org_name",
          key: "label",
          inputType: "input",
        },
        {
          label: "dialog.open.parent_org",
          key: "pname",
          inputType: "tree",
          options: this.orgdata,
        },
        {
          label: "dialog.open.description",
          key: "describe",
          inputType: "textarea",
        },
      ],
      form: {
        label: "",
        pname: "",
        describe: "",
        id: "",
      },
      rules: {
        label: [{ required: true, validator: validateOrg, trigger: "blur" }],
        pname: [{ required: true, message: "请选择上级机构", trigger: "blur" }],
        describe: [{ required: true, message: "请输入描述", trigger: "blur" }],
      },
    };
  },
  computed: {
    title() {
      if (this.editOrgState == 1) {
        // 新增
        return this.$t("dialog.open.add_org");
      } else {
        // 编辑
        return (
          this.$t("dialog.open.edit_org") + "【" + this.rowInfo.label + "】"
        );
      }
    },
    currentFormItem() {
      return this.formItem;
    },
  },
  watch: {
    show: {
      handler(val) {
        if (this.editOrgState == 1) {
          this.form = {
            label: "",
            pname: "",
            describe: "",
            id: "",
          };
        } else {
          //  此处需要处理上级机构f
          this.form = JSON.parse(JSON.stringify(this.rowInfo));
        }
      },
      deep: true,
    },
  },
  methods: {
    handleCheckChange(data, e, l) {
      // console.log(data, "ddddddd"); // 可以拿到描述信息
      this.form.pname = data.label;
      this.form.id = data.id;
      this.$refs.tree[0].setCheckedKeys([data.id]);
    },
    handleOrgChange() {
      //   更换机构
    },
    handleClose(done) {
      this.$emit("toggleShow", false);
      this.$refs.form.clearValidate();
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let param = {
            name: this.form.label,
            describe: this.form.describe,
          };
          // 此处判断新增还是编辑
          //   let cusFunc =
          if (this.editOrgState == 1) {
            // 新增
            param.pid = this.form.id;
            createOrg(param).then((res) => {
              if (res.code == 200) {
                this.handleClose();
                this.$emit("refush");
              }
              this.$message({
                message: "机构创建成功",
                type: res.code == 200 ? "success" : "error",
              });
            });
          } else {
            // 编辑
            param.org_id = this.rowInfo.id;
            // console.log(this.rowInfo, "rrrrrrr")
            editOrg(param).then((res) => {
              if (res.code == 200) {
                this.handleClose();
                this.$emit("refush");
              }
              this.$message({
                message: "机构编辑成功",
                type: res.code == 200 ? "success" : "error",
              });
            });
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btns {
  justify-content: center;
  .btn {
    width: 180px;
    height: 32px;
  }
  .save {
    background-color: $main_color;
    border-color: $main_color;
    margin-left: 30px;
  }
  .cancel {
    border-color: $main_color;
    background-color: #fff;
    color: $main_color;
  }
}
.form {
  justify-content: center;
  ::v-deep .el-form-item {
    display: flex;
    .el-form-item__label {
      font-weight: bold;
    }
    .el-form-item__content {
      flex: 1;
      margin-left: 0 !important;
      .el-cascader {
        width: 100%;
      }
    }
  }
}
</style>
